/**
 * ****************************************************************************
 * @description     :   Reducer to receive action and change state for holon
 * @created at      :   2023/07/25
 * @created by      :   SonMBG - sonmbg@toploop.co
 * @package         :   dashlite-admin-react
 * @copyright       :   Copyright (c) TOPLOOP
 * @version         :   1.0.0
 * ****************************************************************************
 */

import Actions from "./action";

/**
 * Initial state of app
 */
const initialState = {
    holonMaster: {},
    template: {},
    templates: [],
    templateIds: [],
    templatesNoAttributes: [],
    updateCompanyError: {},
    connectEmployeeError: {}
}

/**
 * Reducer to process change data of app
 * -----------------------------------------
 * @author : QuyPN - 2023/07/18 - create
 * @param  : {Object} state - Current sate of app
 * @param  : {Object} action - information of action will process
 * @access : public
 */
export default function holonReducer(state = initialState, action) {
    switch (action.type) {
        case Actions.GET_HOLON_TEMPLATE_RESPONSE:
            return {
                ...state,
                template: action.payload
            }
        case Actions.CLEAR_HOLON_TEMPLATE:
            return {
                ...state,
                template: {}
            }
        case Actions.GET_HOLON_TEMPLATES_BY_TEMPLATE_IDS_SUCCESS:
            return {
                ...state,
                templates: action.payload
            }
        case Actions.GET_HOLON_TEMPLATES_SUCCESS:
            return {
                ...state,
                templates: action.payload
            }
        case Actions.CLEAR_HOLON_TEMPLATES:
            return {
                ...state,
                templates: []
            }
        case Actions.UPDATE_COMPANY_FAILURE:
            return {
                ...state,
                updateCompanyError: action?.payload,
            }
        case Actions.CLEAR_UPDATE_COMPANY_ERROR:
            return {
                ...state,
                updateCompanyError: {},
            }
        case Actions.CONNECT_EMPLOYEE_FAILURE:
            return {
                ...state,
                connectEmployeeError: action?.payload,
            }
        case Actions.CLEAR_CONNECT_EMPLOYEE_ERROR:
            return {
                ...state,
                connectEmployeeError: {},
            }
        case Actions.GET_HOLON_TEMPLATES_BY_MASTER_CODES_SUCCESS:
            return {
                ...state,
                templates: action.payload,
            }
        case Actions.GET_TEMPLATE_IDS_BY_MASTER_CODES_SUCCESS:
            return {
                ...state,
                templateIds: action.payload,
            }
        case Actions.GET_HOLON_TEMPLATES_NO_ATTRIBUTES_BY_MASTER_CODES_SUCCESS:
            return {
                ...state,
                templatesNoAttributes: action.payload,
            }  
        case Actions.GET_HOLON_MASTER_BY_CODE_SUCCESS:
            return {
                ...state,
                holonMaster: action.payload,
            }  
        default:
            return state;
    }
}
